import { render, staticRenderFns } from "./SettingsDropdownCapitalizedColumn.vue?vue&type=template&id=03814ec3&scoped=true&"
import script from "./SettingsDropdownCapitalizedColumn.vue?vue&type=script&lang=js&"
export * from "./SettingsDropdownCapitalizedColumn.vue?vue&type=script&lang=js&"
import style0 from "./SettingsDropdownCapitalizedColumn.vue?vue&type=style&index=0&id=03814ec3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03814ec3",
  null
  
)

export default component.exports